module.exports = __webpack_public_path__ + "static/prime-6d57846ecd44ee9f594fb4c1c20e2283.png";